<template>
  <div>
    <router-view />
    <go-top></go-top>
  </div>
</template>

<script>
import "./assets/js/jquery-shim.js";
import "./assets/js/script.js";
import GoTop from "@inotom/vue-go-top";

export default {
  name: "App",
  components: {
    GoTop
  }
};
</script>
